import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'
import { withTitle } from '../../../Application';

// material ui

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

// application components
import { Link } from 'react-router-dom'
import {whiteLabelData} from "../../../ui/theme"
import log from 'loglevel'
import {  Trans } from 'react-i18next';
import { t } from 'i18next';


const pageTitle = ''
const title = whiteLabelData.name

const styles = {
    root: {
        flexGrow: 1,
        // zIndex: 1,
        display:"flex",
        overflow: 'hidden',
        justifySelf:"center",
        justifyContent:'center'
        // display: 'flex',
        // height: '100%',
    },
    title: {
        padding: '20px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        },
    },
    subtitle: {
        color: '#004653',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        },
    },
    wrapper: {
        display: 'flex',
        // padding: '64px 0px 0px',
        // [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
            alignContent:"center",
            //marginTop: '10%',
            alignSelf:"center",
        // },
    },
    paper: {
        boxSizing: 'content-box',
        maxWidth: 270,
        padding: '20px 19px 23px 19px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 44,
        marginRight: 34,
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
        },
    },
    button: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'space-between',
    },
}


class SetupAuthView extends PureComponent {
    static defaultProps = {
        title: title,
    }

    static propTypes = {
        title: PropTypes.string,
    }

    render () {
        log.debug(title)
        return (
            // <Layout activeItem={5}  >
                <SetupAuth title={pageTitle} subtitle={this.props.subtitle}/>
            // </Layout>
        )
    }
}



class SetupAuth extends PureComponent {


    render() {
        const { classes } = this.props

        return (
            <div style={styles.root}>
                <Typography style={styles.title} variant="headline">{this.props.title}</Typography>
                <div style={styles.wrapper}>
                    <Paper style={styles.paper}>
                        <Typography variant="h5">  <Trans i18nKey="Global.heading_caution">

                                    </Trans>
                                    </Typography>
                        <br />
                        <Typography variant="subtitle2">
                        <Trans i18nKey="SetupAuthorization.paragraph_caution">
                                    </Trans>

                     </Typography>
                        <div style={styles.button}>
                            <Link to="/" style={{ textDecoration: 'none' }}>
                                <Button
                                    // color="primary"
                                    style={{ color: theme.palette.primary.dark }}
                                > <Trans i18nKey="Global.button_cancel">

                                    </Trans>
                                </Button>
                            </Link>
                            <Link to="/setup" style={{ textDecoration: 'none' }}>
                                <Button
                                    // color="primary"
                                    style={{ color: theme.palette.primary.dark }}
                                ><Trans i18nKey="Global.button_ok">
                                        Ok
                                    </Trans>
                                </Button>
                            </Link>

                        </div>
                    </Paper>
                </div>
            </div>
        )
    }
}

//SetupAuth = withTitle(withStyles(styles)(SetupAuth), title)

export default SetupAuthView
